module.exports = __webpack_public_path__ + "img/enterprise.e7711748.png";